import { v4 } from 'uuid';

export const sharedID = v4();
export const customersID = v4();
export const ClientAreaCustomersID = v4();